import { styled, Tooltip, tooltipClasses, TooltipProps } from '@mui/material';
import { ReactElement } from 'react';
import { StyledComponent } from '@emotion/styled';

export const HtmlTooltip: StyledComponent<TooltipProps> = styled(({ className, ...props }: TooltipProps): ReactElement => <Tooltip {...props} classes={{ popper: className }} />)(({ theme }) => ({
	[`& .${tooltipClasses.tooltip}`]: {
		backgroundColor: '#000',
		color: '#FFF',
		borderRadius: '.75rem',
		fontSize: '1rem',
		border: '1px solid #dadde9',
	},
}));
